<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item v-if="i == 0" :to="{ path: '/Sent' }" replace>已发作业</el-breadcrumb-item>
				<el-breadcrumb-item v-if="i == 1" :to="{ path: '/Perform' }" replace>已完成作业</el-breadcrumb-item>
				<el-breadcrumb-item>查看详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 public_box overflow" :style="{ height: height + 'px' }">
			<div class=" public_padding" v-if="Info.exercise_book_file_type">
				<div class="p_flex">
					<span class="type_size_22 ">{{ Info.name }}</span>
				</div>
				<div class="p_flex p_f_a   p_m_t_20 type_size_18">
					<div class="p_flex center p_f_1">
						<span class="subject_color">{{ Info.classLevel.name }}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{ Info.subject_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<!-- <span >{{age}}道题</span> -->
						<!-- <el-divider direction="vertical"></el-divider> -->
						<span>{{ Info.score }}分</span>
						<div class="divss">{{ Info.already_submit }}人提交</div>
					</div>
				</div>
				<div class="p_flex p_f_a   p_m_t_20 type_size_18">
					<div class="p_flex center p_f_1">
						<span>提交时间 {{ Info.create_date }} 至 {{ Info.submit_date }}</span>
					</div>
				</div>
				<div class="p_m_t_30 type_size_22 subject_color">全部题目</div>
			</div>
			<div class="" v-if="Info.exercise_book_file_type == 3">
				<div id="" >
					<div class="imgs">
						<el-image
							style="width: 100%; height:auto;margin-top: 30px;"
							v-for="(item, index) in Info.exercise_book_file_url"
							:key="index"
							:src="item"
							:preview-src-list="Info.exercise_book_file_url"
						></el-image>
					</div>
				</div>
			</div>
			<div id="" class="" v-if="Info.exercise_book_file_type == 1" style="height: 80%;">
				<div  style="height: 100%;"><iframe :src="Info.exercise_book_file_url" style="width: 100%;height: 100%;"></iframe></div>
			</div>
			<div id="" class="" v-if="Info.exercise_book_file_type == 2" style="height: 80%;">
				<div  style="height: 100%;"><iframe :src="  'https://view.officeapps.live.com/op/view.aspx?src=' + Info.exercise_book_file_url" style="width: 100%;height: 100%;"></iframe></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SentSheet',
	data() {
		return {
			height: 0,
			id: '',
			Info: {},
			i:''
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.i = this.$route.query.i;
	},
	mounted() {
		this.indexInfo();
		this.dataInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/SentSheet') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		dataInfo() {
			this.$request
				.ajax(this)
				.post('/api_teacher/publish_exercise_detail', {
					job_publish_id: this.id
				})
				.then(res => {
					console.log(res);
					this.Info = res.data;
				});
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.public_box {
	background-color: #ffffff;
}
.public_padding {
	padding: 30px 260px 0;
}

>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/sent/sentSheet.vue